import { render, staticRenderFns } from "./BatteryCatalogTable.vue?vue&type=template&id=38d08160&scoped=true"
import script from "./BatteryCatalogTable.vue?vue&type=script&lang=js"
export * from "./BatteryCatalogTable.vue?vue&type=script&lang=js"
import style0 from "./BatteryCatalogTable.vue?vue&type=style&index=0&id=38d08160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d08160",
  null
  
)

export default component.exports